/**
 * Studio glyph as an inline SVG, defined ONCE (the canonical source — the PDF
 * mirrors these paths in pdf/theme.ts `ICON_PATHS.studio`). Strokes
 * use `currentColor`, so the color is whatever you pass via `className`
 * (`text-[#BE7B97]`, `text-[#747474]`, …) or inherit from the parent — the
 * drop-in replacement for the lucide `Warehouse` icon on every studio surface.
 * Renders a real `<svg>`, so `[&>svg]:size-4` / `[&>svg]:text-*` wrappers size
 * and color it too.
 */
export function StudioIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 20 20"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={className}
		>
			<path d="M2.5 8.75L10 2.5L17.5 8.75" />
			<path d="M4.16797 7.91602V17.4993H15.8346V7.91602" />
			<path d="M12.5013 9.16602H7.5013C7.04106 9.16602 6.66797 9.53911 6.66797 9.99935V14.166C6.66797 14.6263 7.04106 14.9993 7.5013 14.9993H12.5013C12.9615 14.9993 13.3346 14.6263 13.3346 14.166V9.99935C13.3346 9.53911 12.9615 9.16602 12.5013 9.16602Z" />
		</svg>
	)
}
